jQuery(window).ready(function($) {

  
  // Carousel

    
  $('.sabias-que-text').slick({
      arrows: false,
      dots: true,
      centerMode: false,
      infinite: true,
      centerPadding: '00px',
      slidesToShow: 1,
      asNavFor: '.sabias-que-logos',
      
  });

  // Carousel

    
  $('.sabias-que-logos').slick({
      arrows: false,
      centerMode: true,
      infinite: true,
      fade: true,
      centerPadding: '00px',
      slidesToShow: 1,
      asNavFor: '.sabias-que-text',
  });
  
    // Carousel

  $('.slick-sabias-carousel').slick({
    arrows: true,
    centerMode: true,
    infinite: false,
    centerPadding: '00px',
    slidesToShow: 1,
    // prevArrow:"<span class='left-arrow'><i class='am-arrow am-arrow-left'></i></span>",
    // nextArrow:"<span class='right-arrow'><i class='am-arrow am-arrow-right'></i></span>",
    prevArrow:"<span class='left-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='23.447' height='41.33' viewBox='0 0 23.447 41.33'><path id='Form_1_Kopie' data-name='Form 1 Kopie' d='M904.975,576.858l15.513,15.625a2.969,2.969,0,0,1,0,4.176,2.917,2.917,0,0,1-4.145,0l-17.586-17.713a2.967,2.967,0,0,1,0-4.175l17.586-17.714a2.916,2.916,0,0,1,4.145,0,2.969,2.969,0,0,1,0,4.175Z' transform='translate(-897.898 -556.192)' fill='#5fc4f3'/></svg></span>",
    nextArrow:"<span class='right-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='23.447' height='41.33' viewBox='0 0 23.447 41.33'><path id='Form_1_Kopie' data-name='Form 1 Kopie' d='M914.27,576.858l-15.513,15.625a2.969,2.969,0,0,0,0,4.176,2.917,2.917,0,0,0,4.145,0l17.586-17.713a2.967,2.967,0,0,0,0-4.175L902.9,557.057a2.916,2.916,0,0,0-4.145,0,2.969,2.969,0,0,0,0,4.175Z' transform='translate(-897.898 -556.192)' fill='#5fc4f3'/></svg></span>",
    
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          centerMode: true,
          centerPadding: '10px',
          slidesToShow: 1
        }
      }
    ]
  });


  /*
  * Carousels Destroy on desktop and Initialize on mobile
  */

  function owlInitialize() {
    if ($(window).width() > 767) {

      $('.slick-porque-amae').slick({
        arrows: true,
        centerMode: false,
        infinite: false,
        centerPadding: '00px',
        slidesToShow: 3,
        // prevArrow:"<span class='left-arrow'><i class='am-arrow am-arrow-left'></i></span>",
        // nextArrow:"<span class='right-arrow'><i class='am-arrow am-arrow-right'></i></span>",
        prevArrow:"<span class='left-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='23.447' height='41.33' viewBox='0 0 23.447 41.33'><path id='Form_1_Kopie' data-name='Form 1 Kopie' d='M904.975,576.858l15.513,15.625a2.969,2.969,0,0,1,0,4.176,2.917,2.917,0,0,1-4.145,0l-17.586-17.713a2.967,2.967,0,0,1,0-4.175l17.586-17.714a2.916,2.916,0,0,1,4.145,0,2.969,2.969,0,0,1,0,4.175Z' transform='translate(-897.898 -556.192)' fill='#5fc4f3'/></svg></span>",
        nextArrow:"<span class='right-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='23.447' height='41.33' viewBox='0 0 23.447 41.33'><path id='Form_1_Kopie' data-name='Form 1 Kopie' d='M914.27,576.858l-15.513,15.625a2.969,2.969,0,0,0,0,4.176,2.917,2.917,0,0,0,4.145,0l17.586-17.713a2.967,2.967,0,0,0,0-4.175L902.9,557.057a2.916,2.916,0,0,0-4.145,0,2.969,2.969,0,0,0,0,4.175Z' transform='translate(-897.898 -556.192)' fill='#5fc4f3'/></svg></span>",
        
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 3
            }
          },
          {
            breakpoint: 600,
            settings: {
              centerMode: true,
              centerPadding: '10px',
              slidesToShow: 1
            }
          }
        ]
      });


    } else {
      $('.slick-porque-amae').filter('.slick-initialized').slick('unslick');
      
    }
  }
  owlInitialize();

  

  // Validate form

  

  // Send Form via Ajax

  $("#am-options-form").submit(function(e){
    
    
    var formData = $("#am-options-form").serializeArray(); //serialize the form into array
    var checked = $("#am-options-form input:checked").length > 0;
    if (!checked){
      $("#label-validate").css("display", "block");
      return false;
    }else{
      $("#label-validate").css("display", "none");
    }
    

    console.log(formData);
    $.ajax({
      method : "POST",
      url: "https://ionserver.site/amae-landings/collect-submissions/submission.php",
      //url: "http://localhost/amae/submission.php",
      data: formData,
      success: function (data) {
        window.location.href = "https://cotizador.amae.com.mx/simulador/";
      },
      error: function (xhr, status, error) {
        console.error(xhr);
        window.location.href = "https://cotizador.amae.com.mx/simulador/";
      }
    }); 

    e.preventDefault();


  });

});



$(document).ready(function () {

  $("#am-options-form").click(function () {

    

  });

});